export const DocumentsTypes = [
    {
        value: "internal",
        title: "Internal",
        creatable: true
    },
    {
        value: "external",
        title: "External",
        creatable: true
    }
];

export const DocumentsCategoryTypes = [
    {
        value: "Data Processing Agreement",
        title: "Data Processing Agreement"
    },
    {
        value: "TOM",
        title: "TOM"
    },
    {
        value: "Certificates",
        title: "Certificates"
    },
    {
        value: "Privacy Statement",
        title: "Privacy Statement"
    },
    {
        value: "Audit Reports",
        title: "Audit Reports"
    },
    {
        value: "policies",
        title: "Policies"
    },
    {
        value: "procedures",
        title: "Procedures"
    },
    {
        value: "Records of Processing (ROPA)",
        title: "Records of Processing (ROPA)"
    },
    {
        value: "International Transfers",
        title: "International Transfers"
    },
    {
        value: "Consent & Legal Basis",
        title: "Consent & Legal Basis"
    },
    {
        value: "Data Breach Documentation",
        title: "Data Breach Documentation"
    },
    {
        value: "EU Declaration of Conformity",
        title: "EU Declaration of Conformity"
    },
    {
        value: "Annex IV Technical Documentation",
        title: "Annex IV Technical Documentation"
    },
    {
        value: "Notified Body Certificate",
        title: "Notified Body Certificate"
    },
    {
        value: "Other",
        title: "Other"
    },
];

export const DocumentsConfidentialityLevels = [
    {
        value: "public",
        title: "Public"
    },
    {
        value: "internal",
        title: "Internal"
    },
    {
        value: "restricted",
        title: "Strictly Confidential"
    },
    {
        value: "confidential",
        title: "Confidential"
    }
];